import { render } from "./ManageInternDataTable.vue?vue&type=template&id=3949ef92&scoped=true"
import script from "./ManageInternDataTable.vue?vue&type=script&lang=js"
export * from "./ManageInternDataTable.vue?vue&type=script&lang=js"

import "./ManageInternDataTable.vue?vue&type=style&index=0&id=3949ef92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3949ef92"]])

export default __exports__